import { Box } from "@material-ui/core";
import React from "react";
import DatePickerComponent from "../../../../Common/DatePickers/DatePickerComponent";

const SignableDocumentsDatePickerSection = ({
  resources,
  dateFrom,
  setDateFrom,
  dateTill,
  setDateTill,
}) => {

  return (
    <Box display="flex" padding="0" sx={{ gap: "15px" }}>
      <DatePickerComponent
        id="signable-documents-valid-from"
        label={resources["ValidFrom"]}
        value={dateFrom}
        onChange={(value) => {
          setDateFrom(value);
        }}
        minDate={new Date("2000-01-01")}
      />

      <DatePickerComponent
        id="signable-documents-valid-till"
        label={resources["ValidTill"]}
        value={dateTill}
        onChange={(value) => {
          setDateTill(value);
        }}
        minDate={dateFrom ? new Date(dateFrom) : new Date("2000-01-01")}
      />
    </Box>
  );
};

export default SignableDocumentsDatePickerSection;
